module.exports = __webpack_public_path__ + "static/img/home_h122px_h5_icon_nor@2x.27d35fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_h5_icon_nor@2x.png
// module id = v9vV
// module chunks = 0